import { GameQuestion, QuizSession } from './question.interface';
import { ClassCreature } from './creature.interface';

export enum GamePhase {
  IDLE = 'IDLE',
  CLASS_SELECT = 'CLASS_SELECT',
  STUDENT_LOADING = 'STUDENT_LOADING',
  HUB = 'HUB',
  /** Top-level manual pick: Trivia → SUBJECT_PICK, Fun Games →
      FUN_GAMES_PICK. The "Select Game" button lands here so manual
      selection always starts from a category choice. */
  GAME_CATEGORY = 'GAME_CATEGORY',
  /** Picker shown when the user chooses "Fun Games" — currently
      Bowling + a "more coming soon" placeholder. */
  FUN_GAMES_PICK = 'FUN_GAMES_PICK',
  /** "Academic Skill Games" flow: pick a subject, then pick one of that
      subject's skill games. Math currently has Mirror Match + Star
      Match; other subjects show a "coming soon" list. */
  ACADEMIC_SUBJECT_PICK = 'ACADEMIC_SUBJECT_PICK',
  ACADEMIC_GAMES_PICK = 'ACADEMIC_GAMES_PICK',
  SUBJECT_PICK = 'SUBJECT_PICK',
  GAME_SELECT = 'GAME_SELECT',
  QUIZ = 'QUIZ',
  QUIZ_RESULT = 'QUIZ_RESULT',
  QUIZ_SUMMARY = 'QUIZ_SUMMARY',
  TEAM_SETUP = 'TEAM_SETUP',
  MINI_GAME_ACTIVE = 'MINI_GAME_ACTIVE',
  MINI_GAME_SUMMARY = 'MINI_GAME_SUMMARY',
  CREATURE_PICK = 'CREATURE_PICK',
  CREATURE_PROFILE = 'CREATURE_PROFILE',
  MAP = 'MAP',
  BATTLE_INVITE = 'BATTLE_INVITE',
  BATTLE_ACTIVE = 'BATTLE_ACTIVE',
  BATTLE_RESULT = 'BATTLE_RESULT'
}

export interface GameSessionState {
  phase: GamePhase;
  quizSession: QuizSession | null;
  creature: ClassCreature | null;
  currentClassId: number | null;
  currentGradeId: number | null;
  isDismissalInterrupt: boolean;
  dismissalStudentName: string | null;
}

export interface DismissalInterruptData {
  studentId: number;
  studentName: string;
  studentImage?: string | null;
  className: string;
  requestId: number;
}
